// ARTLENSS portfolio dataset (bilingual)
export const projects = [
  {
    id: "hidden-red-sea",
    slug: "hidden-red-sea",
    image: "/covers/hidden-red-sea.jpg",
    year: "2025",
    category: "Commercial",
    title: { en: "Cinematic Launch — ARTLENSS", ar: "الانطلاقة السينمائية" },
    short: {
      en: "A new cinematic dawn — ARTLENSS at the heart of Vision 2030.",
      ar: "فجر سينمائي جديد — بصمة ARTLENSS في قلب رؤية 2030.",
    },
    // Custom cinematic layout for this project (Vision 2030 launch page)
    heroLayout: "vision",
    hideMeta: true,
    hideApproach: true,
    hideHighlights: true,
    hideResult: true,
    fullWidthVideo: true,
    vision: {
      title: {
        en: "A New Cinematic Dawn: ARTLENSS at the heart of Vision 2030",
        ar: "فجر سينمائي جديد: بصمة ARTLENSS في قلب رؤية 2030",
      },
      paragraphs: {
        en: [
          "The Kingdom of Saudi Arabia is opening its doors to a new era of visual storytelling — an era where dreams are shaped as films, and where a national vision is translated into images that touch the soul. At the heart of this transformation stands ARTLENSS: a purely Saudi lens, crafting a cinematic language from its own reality — never a translation of someone else's.",
          "Since the launch of Vision 2030, the language of production in the Kingdom has changed forever. The camera is no longer a tool of documentation; it has become a tool of identity — of a nation renewing itself. At ARTLENSS, we believe every frame is a statement, every story is development, and every film is an investment in the national memory.",
          "From Yanbu to AlUla, from Riyadh to Jeddah, we re-tell the Kingdom's story in a global cinematic language worthy of the moment. We don't just produce content — we build a visual archive for a new generation of Saudis, a generation that sees itself on screen as it truly is: ambitious, rooted, and open to the world.",
          "This is the cinematic launch. This is the ARTLENSS signature.",
        ],
        ar: [
          "المملكة العربية السعودية تفتح أبوابها لعصر جديد من الحكاية البصرية — عصرٌ تُصاغ فيه الأحلام كأفلام، وتُترجَم فيه الرؤية إلى صور تُلامس الوجدان. في قلب هذا التحوّل تقف ARTLENSS: عدسةٌ سعوديّةٌ خالصة، تصنع لغةً سينمائيّةً من واقعها، لا من ترجمة واقع غيرها.",
          "منذ تدشين رؤية 2030، تغيّرت لغة الإنتاج في المملكة إلى الأبد؛ لم تعد الكاميرا مجرّد أداةِ تسجيل، بل أصبحت أداةَ تعبيرٍ عن هويّة وطنٍ يتجدّد. ونحن في ARTLENSS نؤمن بأن كل كادرٍ موقف، وكل قصّةٍ تنمية، وكل فيلمٍ استثمارٌ في الذاكرة الوطنيّة.",
          "من ينبع إلى العُلا، ومن الرياض إلى جدّة، نُعيدُ سردَ حكاية المملكة بأسلوبٍ سينمائيٍّ عالميٍّ يليق بالمرحلة. لا نُنتج محتوى فحسب — بل نبني أرشيفاً بصريّاً لجيلٍ جديدٍ من السعوديين، جيلٌ يرى نفسه على الشاشة كما هو: طموحاً، متجذّراً، ومنفتحاً على العالم.",
          "هذه هي الانطلاقة السينمائية. هذه هي بصمة ARTLENSS.",
        ],
      },
    },
    video: "https://www.youtube.com/embed/Oo4_Bj-HC_k",
  },
  {
    id: "aramco-forward",
    slug: "aramco-forward",
    image: "/covers/turning-forward.jpg",
    year: "2025",
    category: "Commercial",
    title: { en: "Turning Forward", ar: "الانطلاق إلى الأمام" },
    short: {
      en: "From a simple idea… to eye-catching content.",
      ar: "من فكرة بسيطة… إلى محتوى يلفت كل العيون.",
    },
    // Metadata removed per client request — only title, short, video and the descriptive body remain.
    hideMeta: true,
    hideHighlights: true,
    hideApproach: true,
    hideResult: true,
    body: {
      en: "A production built from a single spark of an idea, developed into a fully-fledged cinematic piece: shaped shot by shot, crafted with anamorphic wides, a paced edit and a rhythm designed to hold attention from the first frame to the last.",
      ar: "إنتاج انطلق من فكرة بسيطة، ثم تطوّر إلى قطعة سينمائية كاملة: تُصاغ لقطة بلقطة، بلقطات أناموروفيك عريضة، ومونتاج إيقاعي مصمَّم ليأسر الانتباه من أول كادر إلى آخره.",
    },
    video: "https://www.youtube.com/embed/0-2-Yv5DM5U",
  },
  {
    id: "twelve-nights",
    slug: "twelve-nights",
    image: "/covers/basma-tech.jpg",
    year: "2025",
    category: "Event",
    title: { en: "Basma Tech Camp — Closing Ceremony", ar: "معسكر بصمة تقنية — الحفل الختامي" },
    short: {
      en: "My participation in the closing ceremony of the Basma Tech Camp for the Ikhaa Association in Jeddah.",
      ar: "مشاركتي في الحفل الختامي لمعسكر بصمة تقنية لجمعية إخاء بجدة.",
    },
    client: { en: "Ikhaa Association · Jeddah", ar: "جمعية إخاء · جدة" },
    goal: { en: "Cover a landmark community event with cinematic multi-camera coverage.", ar: "تغطية حدث مجتمعي بارز بتصوير سينمائي متعدد الكاميرات." },
    timeline: { en: "Single-day live production", ar: "إنتاج مباشر ليوم واحد" },
    approachHeadline: {
      en: "Concept · Visual style · Techniques",
      ar: "الفكرة · الأسلوب البصري · التقنيات",
    },
    approach: {
      en: "A three-camera setup mixing wide stage coverage, roving handheld, and audience portraiture, edited into a highlight reel.",
      ar: "إعداد بثلاث كاميرات يمزج بين تغطية عريضة للمسرح ولقطات محمولة متجولة وصور من الجمهور، مع مونتاج ريل مختصر.",
    },
    equipment: ["Sony FX6 x3", "DJI Ronin", "Sennheiser wireless"],
    locations: { en: "Ikhaa Association · Jeddah", ar: "جمعية إخاء · جدة" },
    team: { en: "Director, DP, 2 camera ops, sound, editor", ar: "مخرج، مدير تصوير، مصوّران، صوت، مونتير" },
    tools: ["DaVinci Resolve", "After Effects"],
    hideHighlights: true,
    resultBackground: "/covers/basma-tech.jpg",
    result: {
      en: "Delivered highlight reel used across the association's social channels and end-of-year report.",
      ar: "تسليم ريل ملخّص استُخدم عبر قنوات الجمعية وتقريرها السنوي.",
    },
    video: "https://www.youtube.com/embed/vVtMAmHkDh0",
  },
  {
    id: "deceptive-mask",
    slug: "deceptive-mask",
    image: "/covers/deceptive-mask.jpg",
    year: "2020",
    category: "Drama",
    title: { en: "The Deceptive Mask (Short Film)", ar: "الكمامة الخادعة (فيلم قصير)" },
    short: {
      en: "A short drama film — story, screenplay & dialogue by Yasser Awkal; directed by Hani Hijazi.",
      ar: "فيلم قصير — قصة وسيناريو وحوار: ياسر عوكل. إخراج: هاني حجازي.",
    },
    client: { en: "Art Lens (formerly Rawa'e Al-Ikhraj) · Fantasy Arts", ar: "Art Lens (سابقاً روائع الإخراج) · فانتازي آرتس" },
    goal: {
      en: "A character-driven short film exploring appearances vs. reality in a contemporary Saudi setting.",
      ar: "فيلم قصير مدفوع بالشخصيات يستكشف المظهر والحقيقة في سياق سعودي معاصر.",
    },
    timeline: { en: "Short-film production", ar: "إنتاج فيلم قصير" },
    approach: {
      en: "An ensemble drama built on restrained interior lighting and dialogue-led scenes, cut for pacing that keeps the viewer inside the deception until the final reveal.",
      ar: "دراما جماعية مبنية على إضاءة داخلية مضبوطة ومشاهد تعتمد على الحوار، بمونتاج إيقاعي يُبقي المشاهد داخل خدعة الحكاية حتى الكشف الأخير.",
    },
    equipment: { en: "Cinema camera package", ar: "طاقم كاميرا سينمائي" },
    locations: { en: "Interior sets · KSA", ar: "مواقع داخلية · المملكة العربية السعودية" },
    team: {
      en: "Director: Hani Hijazi · Writer: Yasser Awkal · Asst. Director: Mohammed Sibgha · Producer: Turki Bakhsh · DP: Nooh Mahmoud",
      ar: "المخرج: هاني حجازي · الكاتب: ياسر عوكل · مساعد المخرج: محمد صبغة · مدير الإنتاج: تركي بخش · مدير التصوير: نوح محمود",
    },
    tools: ["DaVinci Resolve", "Premiere Pro"],
    result: {
      en: "Released as a short-film production under Art Lens (formerly Rawa'e Al-Ikhraj) and Fantasy Arts.",
      ar: "صدر كإنتاج فيلم قصير من Art Lens (سابقاً روائع الإخراج) وفانتازي آرتس.",
    },
    video: "",
  },
  {
    id: "camp-operetta",
    slug: "camp-operetta",
    image: "/covers/camp-operetta.jpg",
    year: "2025",
    category: "Music Video",
    title: { en: "The Camp Operetta", ar: "أوبريت المخيم" },
    short: {
      en: "The story begins with the melody — a musical operetta produced for the camp's opening.",
      ar: "من اللحن تبدأ الحكاية.. أوبريت المخيم.",
    },
    client: { en: "Youth Camp — private production", ar: "مخيم شبابي — إنتاج خاص" },
    goal: { en: "Craft a musical opening piece that carries the camp's spirit through song and image.", ar: "صياغة افتتاحية غنائية تحمل روح المخيم عبر اللحن والصورة." },
    timeline: { en: "Musical short-form production", ar: "إنتاج غنائي قصير" },
    approach: {
      en: "A song-first structure with layered performance cutaways, group choreography and location B-roll, cut precisely to the melody so image, movement and music breathe together.",
      ar: "بنية تبدأ من الأغنية أولاً، مع لقطات أداء متطبّقة وحركة جماعية ومشاهد ميدانية مركّبة على اللحن بدقّة — لتتنفّس الصورة والحركة والموسيقى معاً.",
    },
    equipment: { en: "Cinema kit + audio recording", ar: "طاقم سينمائي + تسجيل صوتي" },
    locations: { en: "Camp grounds · KSA", ar: "موقع المخيم · المملكة العربية السعودية" },
    team: { en: "Director, DP, music producer, editor", ar: "مخرج، مدير تصوير، منتج موسيقي، مونتير" },
    tools: ["DaVinci Resolve", "Premiere Pro", "Logic Pro"],
    hideHighlights: true,
    result: { en: "Released as the camp's opening operetta and shared across social channels.", ar: "صدر كأوبريت افتتاحي للمخيم وانتشر عبر القنوات الاجتماعية." },
    video: "https://www.youtube.com/embed/5kk8HMHf9Gg",
  },
  {
    id: "kingdom-in-motion",
    slug: "kingdom-in-motion",
    image: "/covers/the-host.jpg",
    year: "2026",
    category: "Motion Graphics",
    title: { en: "The Host — Where the Story Begins", ar: "المضيف — حيث تبدأ الحكاية" },
    short: {
      en: "The host… where the story begins.",
      ar: "المضيف… حيث تبدأ الحكاية.",
    },
    client: { en: "Private client", ar: "عميل خاص" },
    goal: { en: "Craft a signature brand film that opens the customer's story from the moment of arrival.", ar: "صياغة فيلم علامة يفتتح حكاية العميل من لحظة الوصول." },
    timeline: { en: "Short-form brand production", ar: "إنتاج قصير للعلامة" },
    approach: {
      en: "Motion graphics and typography carrying warm interior tones — a paced, character-led opening that builds anticipation before the reveal.",
      ar: "موشن جرافيك وتايبوجرافي بألوان دافئة داخلية — افتتاحية متأنّية تتمحور حول الشخصية وتبني الترقّب قبل الكشف.",
    },
    equipment: { en: "Motion graphics · typography · sound design", ar: "موشن جرافيك · تايبوجرافي · تصميم صوت" },
    locations: { en: "In-house post · KSA", ar: "معالجة داخلية · المملكة العربية السعودية" },
    team: { en: "Director · VO artist · Designer", ar: "مخرج · معلق صوتي · مصمم" },
    tools: ["After Effects", "DaVinci Resolve", "Illustrator"],
    hideHighlights: true,
    result: { en: "Delivered as the brand's opening film across social channels.", ar: "سُلِّم كفيلم افتتاحي للعلامة على القنوات الاجتماعية." },
    video: "https://www.youtube.com/embed/Jk9L_eJCgeg",
  },
  {
    id: "mirage-protocol",
    slug: "mirage-protocol",
    image: "/services/product-photography.jpg",
    year: "2025",
    category: "Product Photography",
    title: { en: "Product Photography", ar: "تصوير المنتجات" },
    short: {
      en: "Cinematic product photography for brands, campaigns and menus.",
      ar: "تصوير سينمائي للمنتجات للعلامات والحملات وقوائم المنيو.",
    },
    client: { en: "Brand & F&B clients", ar: "علامات ومطاعم" },
    goal: { en: "Craft hero product stills that carry a cinematic mood while staying commercially clean.", ar: "لقطات بطلة للمنتجات بمزاج سينمائي مع نظافة تجارية عالية." },
    timeline: { en: "Studio shoot production", ar: "إنتاج تصوير استوديو" },
    approach: {
      en: "Controlled studio lighting, styled backgrounds, and directed art-direction — retouched for hero placement.",
      ar: "إضاءة استوديو مضبوطة، خلفيات منسّقة، وإدارة فنية موجَّهة — مع ريتوش يليق باللقطات الرئيسية.",
    },
    equipment: { en: "Cinema camera · prime lenses · continuous lighting", ar: "كاميرا سينمائية · عدسات ثابتة · إضاءة مستمرة" },
    locations: { en: "Studio · Jeddah", ar: "استوديو · جدة" },
    team: { en: "Director, DP, stylist, retoucher", ar: "مخرج، مدير تصوير، مصمّم، ريتوشر" },
    tools: ["Capture One", "Photoshop", "DaVinci Resolve"],
    result: { en: "Delivered as hero stills across menus, campaigns, and social launches.", ar: "سُلِّم كصور رئيسية للمنيو والحملات والإطلاقات الاجتماعية." },
    video: "",
  },
  {
    id: "sound-recording",
    slug: "sound-recording",
    image: "/services/sound-recording.jpg",
    year: "2025",
    category: "Sound Recording",
    title: { en: "Professional Sound Recording", ar: "التسجيل الصوتي باحترافيه" },
    short: {
      en: "Studio-grade voice recording, ADR, foley and sound design — treated, mixed and mastered in-house.",
      ar: "تسجيل صوتي احترافي داخل الاستوديو: تعليق صوتي، ADR، فولي وتصميم صوت — مع معالجة ومكس وماستر.",
    },
    client: { en: "Brands · films · podcasts", ar: "علامات · أفلام · بودكاست" },
    goal: { en: "Deliver broadcast-grade voice and sound assets in a sound-treated room.", ar: "تسليم مواد صوتية بمعايير البث داخل غرفة صوت معزولة." },
    timeline: { en: "Session-based production", ar: "إنتاج بحسب الجلسة" },
    approach: {
      en: "Directed sessions, careful mic selection, and clean editing before mixing to broadcast loudness.",
      ar: "جلسات موجَّهة، اختيار دقيق للميكروفون، مونتاج نظيف قبل المكس بمعايير البث.",
    },
    equipment: { en: "Condenser mics · treated booth · DAW", ar: "ميكروفونات كوندنسر · غرفة معزولة · DAW" },
    locations: { en: "Art Lens Studio · Jeddah", ar: "استوديو Art Lens · جدة" },
    team: { en: "Sound engineer, editor, mixer", ar: "مهندس صوت، مونتير، ميكسر" },
    tools: ["Pro Tools", "iZotope RX", "Waves"],
    result: { en: "Delivered as final mixed and mastered audio assets.", ar: "تسليم مواد صوتية بمكس وماستر نهائي." },
    video: "",
  },
];

export const categories = ["All", "Documentary", "Commercial", "Drama", "Music Video", "Motion Graphics", "Product Photography", "Sound Recording", "Event", "Behind the Scenes"];
